import {AfterViewInit, Directive, ElementRef, HostBinding, OnInit} from '@angular/core';
import * as marked from 'marked';
import {ComponentContainerComponent} from '../components/component-container/component-container.component';

@Directive({
  selector: 'h1,h2,h3', // tslint:disable-line:directive-selector
})
export class HeadlineDirective implements OnInit, AfterViewInit {
  readonly depth: number;

  @HostBinding('attr.id')
  readonly id: string;
  readonly text: string;

  constructor(private readonly elementRef: ElementRef<HTMLElement>, private readonly componentContainer: ComponentContainerComponent) {
  }

  ngOnInit() {
    (this as any).depth = parseInt(this.elementRef.nativeElement.nodeName[1], 10) + 1;
    const slugger = new marked.Slugger();
    (this as any).id = slugger.slug((this as any).text = this.elementRef.nativeElement.innerText);
  }

  ngAfterViewInit() {
    this.componentContainer.headlines.push({ text: this.text, depth: this.depth, anchor: this.id });
  }
}
